import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  heading: `Already a partner?`,
}

const link = {
  text: `Log in to the partner portal`,
  url: `https://partners.segment.com/English/`,
}

const AlreadyAPartner: FC<PropsWithChildren<unknown>> = () => {
  return (
    <SectionStyled variant="centered">
      <CopyTextBase centered={true}>
        <CopyText.Heading>{copy.heading}</CopyText.Heading>
        <CopyText.Link href={link.url}>{link.text}</CopyText.Link>
      </CopyTextBase>
    </SectionStyled>
  )
}

const SectionStyled = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-bottom: 0;
    ${({ theme }) => theme.breakpoints.down(`lg`)} {
      padding-top: 0;
      row-gap: 40px;
    }
  }
`

export default AlreadyAPartner
